import classNames from 'classnames';
import SkeletonLoader from '@/components/atoms/skeleton-loader/skeleton-loader';
import Typography from '@/components/atoms/typography/typography';
import AnchorLink from '@/components/molecules/anchor-link/anchor-link';
import { useI18n } from '@/libraries/contexts/i18n-context';
import styles from './room-matrix-headline.module.scss';

interface RoomMatrixHeadlineProps {
  /** Additional class names */
  className?: string;
  /** The headline display */
  headline: string;
  /** Whether to display the loading state */
  isLoading?: boolean;
  /** The link to display */
  link?: Content.Properties.Link | null;
  /** The tags to display */
  tags: string[];
}

const RoomMatrixHeadline = ({
  className,
  headline,
  isLoading = false,
  link,
  tags = [],
}: RoomMatrixHeadlineProps) => {
  const { t } = useI18n();

  if (isLoading) {
    return (
      <div className={classNames(styles.component, className)}>
        <SkeletonLoader className={styles.loader} height="28px" width="70%" />

        <SkeletonLoader className={styles.loader} height="20px" width="90%" />
      </div>
    );
  }

  return (
    <div className={classNames(styles.component, className)}>
      <Typography tagStyle="headingMedium">{headline}</Typography>

      <Typography tagStyle="bodyMedium">{`${t('items.modules.roomMatrix.facilitiesInRoom')} ${tags.join(' – ')}`}</Typography>

      {link && (
        <AnchorLink className={styles.link} icon="ArrowRight" {...link} />
      )}
    </div>
  );
};

RoomMatrixHeadline.displayName = 'RoomMatrixHeadline';

export default RoomMatrixHeadline;
